import {
    Box,
    FormControlLabel,
    InputLabel,
    Radio,
    RadioGroup,
} from '@mui/material'
import { ReactElement } from 'react'

export interface RadioListType {
    label: string
    value: string
}

interface RadioInputProps {
    id: string
    label: string
    value: string
    onChange: any
    list: any
    disableEdit: boolean
}

const RadioInput = (props: RadioInputProps): ReactElement => {
    const { id, label, value, onChange, list, disableEdit } = props

    return (
        <Box sx={{ width: '100%' }}>
            <InputLabel
                id={id + '-label'}
                sx={{ opacity: '0.7', fontSize: '14px' }}
            >
                {label}
            </InputLabel>
            <RadioGroup
                aria-labelledby={id + '-label'}
                name={id + '-radio-group'}
                value={value}
                onChange={(e) => onChange(id, e.target.value)}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                }}
                title={label}
            >
                {list.length &&
                    list.map((item: RadioListType, index: number) => (
                        <FormControlLabel
                            id={id + '-' + item.label}
                            value={item.value}
                            disabled={disableEdit}
                            control={<Radio />}
                            label={item.label}
                            sx={{ fontSize: '14px' }}
                            key={index}
                        />
                    ))}
            </RadioGroup>
        </Box>
    )
}

export default RadioInput
